
import React from "react";
import Mouse from "../../../../components/Mouse/Mouse";
import ScrollTop from "../../../../components/ScrollTop/ScrollTop";
import Footer from "../Footer/Footer";
import FlatTitle from "./components/FlatTitle";
import ContactInfo from "./components/ContactInfo";
import Message from "./components/Message";
import Map from "./components/Map";
export const metadata = {
  title: "Contact Us || MunAi - AI Writer & Copywriting Nextjs Template",
  description: "MunAi - AI Writer & Copywriting Nextjs Template",
};

export default function ContactUs() {
  return (
    <>
      <div id="wrapper">
        <div id="page" className="">
          <FlatTitle pageName={"Contact Us"}/>
          <ContactInfo />
          <Message />
          <Map />

          <Footer />
        </div>
      </div>
      <Mouse />
      <ScrollTop />
    </>
  );
}
